// extracted by mini-css-extract-plugin
export default {"headerBg":"header_headerBg__C2quW","trigger":"header_trigger__9Eoms"};